import { EmployerAgreementsService } from '@festina/life-general-types/life/services/EmployerAgreementsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { ExtractLiteralStrings } from '@festina-life/core'

const method = EmployerAgreementsService.employerAgreementServicePutUpdateEntity

type MethodRequestBody = NonNullable<
  Parameters<typeof method>[0]['requestBody']
>
type TriggerProps = NonNullable<MethodRequestBody['commandData']>

type Props = {
  tenantId: string
  employerAgreementId: string
  commandType: ExtractLiteralStrings<
    MethodRequestBody['commandType'],
    | 'amendEmployerAgreementCovers'
    | 'amendEmployerAgreementPolicies'
    | 'amendEmployerAgreement'
  >
}

export const useAmendEmployerAgreementCommand = ({
  tenantId,
  employerAgreementId,
  commandType,
}: Props) =>
  useFestinaMutation({
    component: 'life',
    roles:
      EmployerAgreementsService.employerAgreementServicePutUpdateEntity_roles,
    isScenario: false,
    mutateFunction: async (arg: TriggerProps) => {
      await method({
        xTenantId: tenantId,
        employerAgreementId,
        requestBody: {
          _type: 'CreateEmployerAgreementCommand',
          commandData: arg,
          commandType,
        },
      })
    },
  })
